<template>
	<!-- 气泡弹出层  按钮 -->
	<div
		style="display: inline-block"
		:class="customClass"
		@click.stop="openPopover"
		ref="reference"
	>
		<slot name="reference"></slot>
	</div>

	<nut-popup
		ref="popoverRef"
		:pop-class="classes"
		v-model:visible="showPopup"
		:overlay="false"
		position=""
		@clickOverlay="clickOverlay"
	>
		<!-- 气泡弹出层  箭头 -->
		<div :class="popoverArrow" v-if="showArrow"></div>
		<!-- 气泡弹出层  内容 -->
		<slot name="content"></slot>
	</nut-popup>
</template>
<script>
import {
	onMounted,
	computed,
	watch,
	ref,
	toRefs,
	nextTick,
	onUnmounted,
} from 'vue';
import { createPopper } from '@popperjs/core/lib/popper-lite';
import offsetModifier from '@popperjs/core/lib/modifiers/offset';

export default {
	inheritAttrs: false,
	props: {
		visible: {
			type: Boolean,
		},
		theme: {
			type: String,
			default: 'light',
		},

		location: {
			type: String,
			default: 'bottom',
		},
		// 位置出现的偏移量
		offset: {
			type: Array,
			default: () => [0, 12],
		},
		customClass: {
			type: String,
			default: '',
		},
		showArrow: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['update', 'update:visible', 'close', 'choose', 'open'],
	setup(props, { emit }) {
		let popper;
		const reference = ref();
		const popoverRef = ref();

		const showPopup = ref(props.visible);

		const { theme, location } = toRefs(props);

		const classes = computed(() => {
			const prefixCls = 'nut-popover';

			return `${prefixCls} ${prefixCls}--${theme.value}`;
		});

		const popoverArrow = computed(() => {
			const prefixCls = 'popover-arrow';
			return {
				[prefixCls]: true,
				[`${prefixCls}--${location.value}`]: location.value,
			};
		});

		const createPopperInstance = () => {
			if (reference.value && popoverRef.value) {
				return createPopper(
					reference.value,
					popoverRef.value.popupRef,
					{
						placement: props.location,
						modifiers: [
							{
								name: 'computeStyles',
								options: {
									adaptive: false,
									gpuAcceleration: false,
								},
							},
							Object.assign({}, offsetModifier, {
								options: {
									offset: props.offset,
								},
							}),
						],
					}
				);
			}
			return null;
		};

		const clickOverlay = () => {
			// console.log('关闭');
		};

		const uploadLocation = () => {
			nextTick(() => {
				if (!showPopup.value) return;
				if (!popper) {
					popper = createPopperInstance();
				} else {
					popper.setOptions({
						placement: props.location,
					});
				}
			});
		};

		const clickAway = (event) => {
			const element = reference.value;
			if (element && !element.contains(event.target)) {
				closePopover();
			}
		};
		onMounted(() => {
			window.addEventListener('click', clickAway, true);
		});

		onUnmounted(() => {
			window.removeEventListener('click', clickAway, true);
		});

		watch(
			() => props.visible,
			(value) => {
				showPopup.value = value;
				uploadLocation();
			}
		);

		watch(
			() => props.location,
			() => {
				uploadLocation();
			}
		);

		const update = (val) => {
			emit('update', val);
			emit('update:visible', val);
		};

		const openPopover = () => {
			update(!props.visible);
			emit('open');
		};

		const closePopover = () => {
			emit('close');
			emit('update:visible', false);
		};

		return {
			classes,
			showPopup,
			openPopover,
			popoverArrow,
			closePopover,
			reference,
			popoverRef,
			clickOverlay,
		};
	},
};
</script>
<style lang="scss">
.nut-popover {
	overflow-y: inherit;
	transform: inherit;

	// 遮罩
	.more-background {
		opacity: 0;
		position: fixed;
		width: 100%;
		height: 100%;
		z-index: 10;
		left: 0;
		top: 0;
	}

	.popover-arrow {
		position: absolute;
		width: 0;
		height: 0;
		border: 8px solid transparent;
	}
	// top
	&[data-popper-placement^='top'] {
		.popover-arrow {
			bottom: 0;
			border-top-color: $popover-white-background-color;
			border-bottom-width: 0;
			margin-bottom: -8px;
		}
	}

	&[data-popper-placement='top'] {
		.popover-arrow {
			left: 50%;
			transform: translateX(-50%);
		}
	}

	&[data-popper-placement='top-start'] {
		.popover-arrow {
			left: 16px;
			transform: translateX(0%);
		}
	}

	&[data-popper-placement='top-end'] {
		.popover-arrow {
			right: 16px;
			transform: translateX(0%);
		}
	}

	// left
	&[data-popper-placement^='left'] {
		.popover-arrow {
			right: 0px;
			border-left-color: $popover-white-background-color;
			border-right-width: 0;
			margin-right: -8px;
		}
	}

	&[data-popper-placement='left'] {
		.popover-arrow {
			top: 50%;
			transform: translateY(-50%);
		}
	}

	&[data-popper-placement='left-start'] {
		.popover-arrow {
			top: 16px;
			transform: translateY(0%);
		}
	}

	&[data-popper-placement='left-end'] {
		.popover-arrow {
			bottom: 16px;
			transform: translateY(0%);
		}
	}

	// right

	&[data-popper-placement^='right'] {
		.popover-arrow {
			left: 0px;
			border-right-color: $popover-white-background-color;
			border-left-width: 0;
			margin-left: -8px;
		}
	}

	&[data-popper-placement='right'] {
		.popover-arrow {
			top: 50%;
			transform: translateY(-50%);
		}
	}

	&[data-popper-placement='right-start'] {
		.popover-arrow {
			top: 16px;
			transform: translateY(0%);
		}
	}

	&[data-popper-placement='right-end'] {
		.popover-arrow {
			bottom: 16px;
			transform: translateY(0%);
		}
	}
	// bottom
	&[data-popper-placement^='bottom'] {
		.popover-arrow {
			top: 0px;
			border-bottom-color: $popover-white-background-color;
			border-top-width: 0;
			margin-top: -8px;
		}
	}

	&[data-popper-placement='bottom'] {
		.popover-arrow {
			left: 50%;
			transform: translateX(-50%);
		}
	}

	&[data-popper-placement='bottom-start'] {
		.popover-arrow {
			left: 16px;
			transform: translateX(0%);
		}
	}

	&[data-popper-placement='bottom-end'] {
		.popover-arrow {
			right: 16px;
			transform: translateX(0%);
		}
	}

	.disabled {
		color: $popover-disable-color;
		cursor: not-allowed;
	}
}

.nut-popover--dark {
	color: $popover-white-background-color;

	&[data-popper-placement^='top'] {
		.popover-arrow {
			border-top-color: $popover-dark-background-color;
		}
	}

	&[data-popper-placement^='left'] {
		.popover-arrow {
			border-left-color: $popover-dark-background-color;
		}
	}

	&[data-popper-placement^='right'] {
		.popover-arrow {
			border-right-color: $popover-dark-background-color;
		}
	}

	&[data-popper-placement^='bottom'] {
		.popover-arrow {
			border-bottom-color: $popover-dark-background-color;
		}
	}
}
</style>
